import { registerRoleHomeLoaders } from '../utils/ui/prefetchRoleHome';

/**
 * The role homes' chunk loaders, registered once at app start (index.js) so
 * sign-in can warm the signed-in role's home early (utils/ui/prefetchRoleHome).
 * Same specifiers as App.js's AppShell lazy and AppShell's per-role lazies, so
 * the chunks are shared. Lives at the entry so no shared module imports every
 * role's home.
 */
const loadAdminHome = () => import('./AdminHome');

registerRoleHomeLoaders({
  shell: () => import('./AppShell'),
  admin: loadAdminHome,
  operations: loadAdminHome,
  billing: () => import('./BillingHome'),
  worker: () => import('./WorkerHome'),
  supervisor: () => import('./SupervisorHome'),
});
